import { CarriersListResponse } from "models/dto/CarriersListResponse";
import { ExcelRow } from "components/_shared/ExportToExcel/exportToExcel";
import { getStatus } from "../../CarrierLabelBadge/CarrierLabelBadge";
import {
  carrierListColumns,
  CarrierListColumnKey,
} from "../carrierListColumns";
import { getCarrierCellValues } from "./carrierListUtilities";

type CellValues = ReturnType<typeof getCarrierCellValues>;

const exportValueByColumn: Partial<
  Record<
    CarrierListColumnKey,
    (carrier: CarriersListResponse, values: CellValues) => string
  >
> = {
  status: (carrier) => getStatus(carrier.statusCodeId).text,
  carrier: (_, values) => values.carrierName,
  phone: (_, values) => values.phone,
  email: (_, values) => values.email,
  cityState: (_, values) => values.address,
  country: (_, values) => values.country,
  repAccount: (_, values) => values.carrierOwner,
  fleetSize: (_, values) => values.fleetSize,
  shippeoOnboarded: (_, values) => values.shippeoOnboarded,
  lastActivity: (_, values) => values.lastActivityTime,
  lastDelivered: (_, values) => values.lastShipmentDelivered,
  note: (_, values) =>
    `${values.lastActivitySummary}\n${values.lastActivityNote}`,
};

export const getCarrierExportColumns = (
  visibleColumns: CarrierListColumnKey[]
) =>
  carrierListColumns.filter(
    (column) =>
      visibleColumns.includes(column.key) && exportValueByColumn[column.key]
  );

export const getCarrierExportRows = (
  carriers: CarriersListResponse[],
  visibleColumns: CarrierListColumnKey[]
): ExcelRow[] => {
  const columns = getCarrierExportColumns(visibleColumns);

  return carriers.map((carrier) => {
    const values = getCarrierCellValues(carrier);

    return Object.fromEntries(
      columns.map((column) => [
        column.text,
        exportValueByColumn[column.key]?.(carrier, values) ?? null,
      ])
    );
  });
};
